import { render, staticRenderFns } from "./EditPaintList.vue?vue&type=template&id=50f17a60&scoped=true&"
import script from "./EditPaintList.vue?vue&type=script&lang=js&"
export * from "./EditPaintList.vue?vue&type=script&lang=js&"
import style0 from "./EditPaintList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditPaintList.vue?vue&type=style&index=1&id=50f17a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f17a60",
  null
  
)

export default component.exports